/* GENERATED by `npm run strings` from src/strings/*.yml — DO NOT EDIT.
   Change the wording in the YAML, then regenerate. */
export const STRINGS = {
  "audience": {
    "media": {
      "title": "تابع الشاشة الرئيسية",
      "hint": "يُعرض الآن فيديو على الشاشة أمامك."
    },
    "prompts": {
      "now": "أوامر جاهزة للنسخ",
      "earlier": "أوامر سابقة"
    }
  },
  "blocks": {
    "media": {
      "pending": "بانتظار التصوير",
      "on_main_screen": "يُعرض على الشاشة الرئيسية",
      "unmute": "الصوت مغلق، اضغط لتشغيله"
    },
    "image": {
      "pending": "بانتظار لقطة الشاشة"
    },
    "prompt": {
      "copy": "نسخ الأمر",
      "copied": "تم النسخ",
      "failed": "تعذّر النسخ، انسخه يدوياً"
    }
  },
  "display": {
    "replaced": {
      "title": "هذه الشاشة لم تعد شاشة العرض",
      "hint": "فُتحت شاشة عرض أخرى لهذه الغرفة، والغرفة تعمل بشاشة واحدة فقط. أغلق هذه النافذة، أو اجعلها شاشة العرض.",
      "take_back": "اجعل هذه الشاشة شاشة العرض"
    },
    "ended": {
      "title": "انتهت الجلسة"
    },
    "exit": {
      "label": "الخروج إلى صفحة العرض (Esc)"
    }
  },
  "export": {
    "button": "تنزيل",
    "menu_label": "تنزيل الدورة كملف Markdown",
    "trainer": {
      "title": "نسخة المدرب",
      "hint": "كل الشرائح مع ملاحظات المدرب والإجابات الصحيحة"
    },
    "handout": {
      "title": "نسخة المتدربين",
      "hint": "محتوى الشرائح فقط، بلا ملاحظات المدرب وبلا الإجابات"
    },
    "unpublished": "انشر إصداراً أولاً",
    "failed": "تعذّر التنزيل"
  },
  "remote": {
    "end_session": {
      "button": "أنهِ الجلسة",
      "warning": "تُغلق الغرفة للجميع ولا تُفتح من جديد. أي جلسة جديدة تبدأ بلا نتائج تصويت.",
      "confirm": "نعم، أنهِ الجلسة",
      "cancel": "تراجع"
    },
    "session_ended": {
      "title": "انتهت الجلسة",
      "hint": "أُغلقت الغرفة. لبدء جلسة جديدة افتح صفحة العرض.",
      "home": "العودة إلى القائمة"
    },
    "media": {
      "label": "الفيديو على الشاشة",
      "play": "تشغيل",
      "pause": "إيقاف مؤقت",
      "restart": "من البداية",
      "pending": "الفيديو بانتظار التصوير"
    }
  },
  "sessionPanel": {
    "display_group_title": "شاشة العرض: اختر طريقة واحدة فقط",
    "present": {
      "title": "من جهازك",
      "hint": "افتحه على اللابتوب الموصول بالبروجكتر، بعد تسجيل دخولك"
    },
    "share_display": {
      "title": "من جهاز آخر",
      "hint": "لجهاز القاعة أو أي جهاز بلا تسجيل دخول. لا تفتحه مع الرابط السابق في الوقت نفسه"
    },
    "remote": {
      "title": "التحكم من موبايل المدرب",
      "hint": "منه تنتقل بين الشرائح وتبدأ التصويت وتعرض النتائج"
    },
    "audience": {
      "title": "صفحة المتدربين",
      "hint": "يفتحونها بمسح رمز QR، ومنها يصوتون ويرسلون أسئلتهم"
    }
  },
  "ui": {
    "link_row": {
      "copy": "نسخ",
      "open": "فتح",
      "copied": "تم"
    }
  }
} as const;
